var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-container"},[_c('div',{staticClass:"text-field__main",class:{
      seriffed: _vm.generalState.font === 'serif',
      monospace: _vm.generalState.font === 'monospace',
      bold: _vm.generalState.weight === 'bold',
      italic: _vm.generalState.weight === 'italic',
    }},[_c('div',{ref:"editableField",staticClass:"textarea-container",style:({
        textAlign: _vm.generalState.alignment,
        textTransform: _vm.generalState.letterCase === 'upper' ? 'uppercase' : 'none',
        fontSize: (_vm.fontSize + "px"),
        color: _vm.getColor(),
        lineHeight: ("" + (_vm.generalState.type === 'paragraph' ? _vm.containerData.lineHeight : 1)),
        letterSpacing: ((_vm.containerData.letterSpacing) + "px"),
      }),attrs:{"contenteditable":"true","id":"main-text","spellcheck":"false"},domProps:{"innerHTML":_vm._s(_vm.currentValue)},on:{"focus":_vm.onFocus,"input":_vm.onInput,"click":_vm.saveSelection,"keyup":_vm.saveSelection}})])])}
var staticRenderFns = []

export { render, staticRenderFns }